"use client";

import { PreviewAdapter, previewRegistry, useViewPreviewRenderArgs } from "@/features/previews";
import { initializePreviewRegistry } from "@/features/previews/registry/initialize";

import { QRViewPageTemplateProps } from "./types";

import "./styles.scss";

export const QRViewPageTemplate = ({ qrData, language }: QRViewPageTemplateProps) => {
  initializePreviewRegistry();

  // Extracted to a hook to separate concerns and having one place for editor preview injection.
  const adapterProps = useViewPreviewRenderArgs({ qrData, language });
  const type = adapterProps?.type;
  const showPreview = Boolean(type && previewRegistry.has(type));

  return (
    <div className="QRCodePage">
      {showPreview && adapterProps ? <PreviewAdapter {...adapterProps} /> : <div />}
    </div>
  );
};
